import { render, staticRenderFns } from "./AddCar.vue?vue&type=template&id=12e6f17a"
import script from "./AddCar.vue?vue&type=script&lang=js"
export * from "./AddCar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports